import { CarrierCargoDetailPagePage } from "@/pages/carrier-cargo-detail";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/carrier/cargos/$id/")({
  component: () => {
    const { id } = useParams({ strict: false });
    return <CarrierCargoDetailPagePage id={id} />;
  },
});
